import { createAction, props } from '@ngrx/store';

import {
    IResultGetGamificacionAutoevaluacion,
    IResultGetGamificacionCuotas,
    IResultGetGamificacionResumen,
    ProgramaCDGTenderos
} from '../../shared/models/ProgramaCDGTenderos.interface';

// Obtener datos del programa CDG
export const getProgamCDG = createAction(
    '[Program CDG] Get Progam CDG',
    props<{ api: string }>()
)

export const successGetCDGProgam = createAction(
    '[Program CDG] Success Get CDG Progam',
    props<{ data: ProgramaCDGTenderos[] }>()
)

export const errorGetCDGProgam = createAction(
    '[Program CDG] Error Get CDG Progam',
    props<{ payload: Error }>()
)

export const completeLoadingProgram = createAction(
    '[Program CDG] Complete Loading Program',
)

// Obtener datos del ticket promedio CDG
export const getAverageTicketCDG = createAction(
    '[Program CDG] Get Average Ticket CDG',
    props<{ programData: ProgramaCDGTenderos[] }>()
)

export const successGetAverageTicketCDG = createAction(
    '[Program CDG] Success Get Average Ticket CDG',
    props<{ data: { averageTicket: number } }>()
)

export const errorGetAverageTicketCDG = createAction(
    '[Program CDG] Error Get Average Ticket CDG',
    props<{ payload: Error }>()
)

// Consultar y almacenar puntos en local storage
export const getPointsStorageCDG = createAction(
    '[Program CDG] Get Points Storage CDG'
)

export const setPointsStorageCDG = createAction(
    '[Program CDG] Set Points Storage CDG',
    props<{ points: number, lastDate: string }>()
)

/*
 * Consulta de resumen dashboard
 */
export const getGamificacionResumen = createAction(
    '[Gamificacion] Get Gamificacion Resumen'
);

export const successGetGamificacionResumen = createAction(
    '[Gamificacion] Success Get Gamificacion Resumen',
    props<IResultGetGamificacionResumen>()
);

export const errorGetGamificacionResumen = createAction(
    '[Gamificacion] Error Get Gamificacion Resumen',
    props<{ payload: Error }>()
);

export const clearGamificacion = createAction(
    '[Gamificacion] Clear Gamificacion'
);

/*
 * Consulta de Autoevaluacion dashboard
 */
export const getGamificacionAutoevaluacion = createAction(
    '[Gamificacion] Get Gamificacion Autoevaluacion'
);

export const successGetGamificacionAutoevaluacion = createAction(
    '[Gamificacion] Success Get Gamificacion Autoevaluacion',
    props<IResultGetGamificacionAutoevaluacion>()
);

export const errorGetGamificacionAutoevaluacion = createAction(
    '[Gamificacion] Error Get Gamificacion Autoevaluacion',
    props<{ payload: Error }>()
);

/*
 * Consulta de Cuotas dashboard
 */
export const getGamificacionCuotas = createAction(
    '[Gamificacion] Get Gamificacion Cuotas'
);

export const successGetGamificacionCuotas = createAction(
    '[Gamificacion] Success Get Gamificacion Cuotas',
    props<IResultGetGamificacionCuotas>()
);

export const errorGetGamificacionCuotas = createAction(
    '[Gamificacion] Error Get Gamificacion Cuotas',
    props<{ payload: Error }>()
);
